//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { rgba } from 'polished';
import styled from 'styled-components';

export const LinkWrapper = styled.span<{
  hasError?: boolean;
}>(
  ({ hasError, theme }) => `
    position: relative;
    background-color: ${rgba(
      hasError ? theme.colors.aliases.error : theme.colors.aliases.primary,
      0.1,
    )};
  `,
);
